import constants from '../constants.js';

const AirportsIsEnabled = {
  displayName: 'Enabled',
  dataAt: 'IsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirportsIsDeleted = {
  displayName: 'Deleted',
  dataAt: 'IsDeleted',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirportsClassification = {
  displayName: 'Classification',
  dataAt: 'Classification',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsElevationFeet = {
  displayName: 'ElevationFeet',
  dataAt: 'ElevationFeet',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsLongitude = {
  displayName: 'Longitude',
  dataAt: 'Longitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsLatitude = {
  displayName: 'Latitude',
  dataAt: 'Latitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsUtcOffsetHours = {
  displayName: 'UTC Offset Hours',
  dataAt: 'UtcOffsetHours',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsTimeZoneRegionName = {
  displayName: 'Time Zone Region Name',
  dataAt: 'TimeZoneRegionName',
  displayAs: constants.DISPLAY_AS.TIME_ZONE_SELECT,
  selectType: 'single',
  required: true
};

const AirportsCityLongitude = {
  displayName: 'City Longitude',
  dataAt: 'CityLongitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsCityLatitude = {
  displayName: 'City Latitude',
  dataAt: 'CityLatitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsCountryCode = {
  displayName: 'Country Code',
  dataAt: 'CountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single',
  required: true
};

const AirportsCityCode = {
  displayName: 'City Code',
  dataAt: 'CityCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsCity = {
  displayName: 'City',
  dataAt: 'City',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsIcao = {
  displayName: 'ICAO',
  dataAt: 'Icao',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsIata = {
  displayName: 'IATA',
  dataAt: 'Iata',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsFs = {
  displayName: 'Airport Code',
  dataAt: 'Fs',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportGroupCode = {
  displayName: 'Group Code',
  dataAt: 'AirportGroupCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirportGroupName = {
  displayName: 'Group Name',
  dataAt: 'AirportGroupName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirportsName = {
  displayName: 'Name',
  dataAt: 'Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsId = {
  displayName: 'Id',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirportsNameLabel = {dataAt: 'Name', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Name:'};

const AirportsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Airports',
  data:
    {
      Name: '',
      Fs: '',
      Iata: '',
      Icao: '',
      City: '',
      CityCode: '',
      CountryCode: '',
      CountryName: '',
      RegionName: '',
      TimeZoneRegionName: '',
      UtcOffsetHours: '',
      Latitude: '',
      Longitude: '',
      ElevationFeet: '',
      Classification: '',
      AirportGroupName: '',
      AirportGroupCode: ''
    },
  dataAt: '',
  children: [AirportsName, AirportGroupName, AirportGroupCode, AirportsFs, AirportsIata, AirportsIcao, AirportsCity, AirportsCityCode, AirportsCountryCode, AirportsCityLatitude, AirportsCityLongitude, AirportsTimeZoneRegionName, AirportsUtcOffsetHours, AirportsLongitude, AirportsLatitude, AirportsElevationFeet, AirportsClassification],
  endpoint: 'Airports'
};

const AirportsResource = {
  displayName: 'Airports',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: 'fa-plane',
  dataAt: '',
  children: [AirportsNameLabel, AirportsId, AirportsName, AirportGroupName, AirportGroupCode, AirportsFs, AirportsIata, AirportsIcao, AirportsCity, AirportsCityCode, AirportsCountryCode, AirportsCityLatitude, AirportsCityLongitude, AirportsTimeZoneRegionName, AirportsUtcOffsetHours, AirportsLatitude, AirportsLongitude, AirportsElevationFeet, AirportsClassification, AirportsIsDeleted, AirportsIsEnabled],
  endpoint: 'Airports',
  routeParamId: 'airportId'
};


let airportCols = [{ name: "Name", key: "Name" },
{ name: "City", key: "City" },
{ name: "Airport Code", key: "Fs" },
{ name: "City Code", key: "CityCode" },
{ name: "Country Code", key: "CountryCode" },
{ name: "Group Code", key: "AirportGroupCode" },

]
const AirportsList = {
  rootNode: true,
  displayName: "Airports",
  displayAs: constants.DISPLAY_AS.SEARCH_BY,
  endpoint: "Airports",
  targetChoices: airportCols,
  resultsSettings: {
    displayName: "Airports",
    gridItem: AirportsResource,
    gridAdd: AirportsAddResource,
    gridCols: airportCols,
    routeParamId: "airportId",
  },
};

export default {
  AirportsList,
  AirportsResource,
  AirportsAddResource,
  AirportsNameLabel,
  AirportsId,
  AirportsName,
  AirportGroupName,
  AirportGroupCode,
  AirportsFs,
  AirportsIata,
  AirportsIcao,
  AirportsCity,
  AirportsCityCode,
  AirportsCountryCode,
  AirportsCityLatitude,
  AirportsCityLongitude,
  AirportsTimeZoneRegionName,
  AirportsUtcOffsetHours,
  AirportsLatitude,
  AirportsLongitude,
  AirportsElevationFeet,
  AirportsClassification,
  AirportsIsDeleted,
  AirportsIsEnabled
}



// WEBPACK FOOTER //
// ./src/config/fields/airports.js